// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {
  getLocator,
  cropImageUrl,
  configureInternalNavigationFromCMSUrl,
} from '@tcp/core/src/utils';
import React, { useEffect, useRef, useState } from 'react';

import LinkText from '@tcp/core/src/components/common/molecules/LinkText';
import CTAItem from '../../CtaItems';
import {
  Slide,
  ImageTag,
  Scroller,
  ImageSlider,
  ColorSlider,
  ScrollerInner,
} from '../styles/MarqueeSlider.style';

const renderTextItem = (headerTextLine, navigation) => {
  return (
    <LinkText
      className="slider-content-innerText"
      headerText={headerTextLine}
      locator="moduleSlider_header_text"
      textAlign="center"
      useStyle
      component="p"
      navigation={navigation}
      noLinkWrap
    />
  );
};

const renderImage = (image) => {
  const { url, alt } = image;
  return (
    <ImageTag
      alt={alt}
      className="marquee-image-item"
      src={cropImageUrl(url)}
      data-locator={getLocator(image?.alt)}
    />
  );
};

const renderSingleSlide = (item, index) => {
  const { headerTextLine, linkedImage, ctaItems } = item;
  const { color, image, link } = !isEmpty(linkedImage) && linkedImage[0];
  const isOnlyImage = !isEmpty(linkedImage) && !isEmpty(image);
  let navigationUrl = {};

  if (link) {
    navigationUrl = link;
    navigationUrl.to = configureInternalNavigationFromCMSUrl(link?.url);
    navigationUrl.asPath = link?.url;
  }

  if (isOnlyImage) {
    return (
      <ImageSlider key={index} className="slide-list-bgimage-item">
        <Slide className="module-slider-marquee-image-link" {...navigationUrl}>
          {renderImage(image)}
          {!isEmpty(headerTextLine) ? renderTextItem(headerTextLine) : <></>}
          {!isEmpty(ctaItems) ? <CTAItem ctaItems={ctaItems} /> : <></>}
        </Slide>
      </ImageSlider>
    );
  }

  return (
    <ColorSlider className="slide-list-bgcolor-item" colorData={color} key={index}>
      <Slide className="module-slider-marquee-color-link" {...navigationUrl}>
        {renderTextItem(headerTextLine)}
        {!isEmpty(ctaItems) ? <CTAItem ctaItems={ctaItems} /> : <></>}
      </Slide>
    </ColorSlider>
  );
};

const MarqueeSlider = ({ slider, animationSpeed, isRightSlideAnimation }) => {
  const scrollerRef = useRef(null);
  const [isCloned, setIsCloned] = useState(false);
  const direction = isRightSlideAnimation ? 'right' : 'left';

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!isCloned) {
      const scroller = scrollerRef.current;
      const scrollerInner = scroller.querySelector('ul');
      const scrollerContent = Array.from(scrollerInner.children);

      scrollerContent.forEach((item) => {
        const clonedItem = item.cloneNode(true);
        clonedItem.setAttribute('aria-hidden', true);
        scrollerInner.appendChild(clonedItem);
      });

      setIsCloned(true);
    }
  }, [isCloned]);

  return (
    <Scroller ref={scrollerRef}>
      <ScrollerInner speed={animationSpeed} direction={direction}>
        {slider.map((item, index) => renderSingleSlide(item, index))}
      </ScrollerInner>
    </Scroller>
  );
};

MarqueeSlider.propTypes = {
  isPositionTopNav: PropTypes.bool,
  animationSpeed: PropTypes.number.isRequired,
  isRightSlideAnimation: PropTypes.bool,
  slider: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

MarqueeSlider.defaultProps = {
  isPositionTopNav: false,
  isRightSlideAnimation: false,
};

export default MarqueeSlider;
